export default {
  form: document.querySelector("#search-form"),
  searchBtn: document.querySelector(".searchBtn"),
  gallery: document.querySelector(".gallery"),
  loadMoreBtn: document.querySelector("#load-more"),
  preloader: document.querySelector(".preloader"),
};
